module.exports = __webpack_public_path__ + "img/banner_2.894ebc34.jpg";